export default {
  id: 'tn-syos-focus-outline-circle',
  path: 'M-8 41C-8 19.56 9.56 2 31 2c21.439 0 39 17.56 39 39zm72 0C64 22.822 49.176 8 31 8 12.82 8-2 22.822-2 41zm-72 0c0 21.44 17.56 39 39 39 21.439 0 39-17.56 39-39zm72 0c0 18.178-14.823 33-33 33C12.82 74-2 59.178-2 41z',
};
